// extracted by mini-css-extract-plugin
export var activityContainer = "_mb-0";
export var typingIndicatorContainer = "_mb-1";
export var typingIndicatorDot = "_mb-2";
export var wave = "_mb-3";